import serviceStatus from './serviceStatus'

export default {
    serviceStatus,
}
